// Fuelly platform branding. This is the only genuinely static "brand" data left
// in the bundle — restaurant name, address, colours, menu and tax rates all come
// from the API (see tenant/TenantProvider).

export const PLATFORM = {
  name: "Fuelly",
  tagline: "One profile. Every healthy restaurant.",
  domain: "fuelly.cloud",
  logo: "/brand/fuelly-logo.png",
};

/**
 * The legal pages at /privacy and /terms.
 *
 * These three values live here rather than in the translation catalogs on
 * purpose: an operator's registered name, its contact address and the date a
 * document last changed are the same fact in every language, and a fact copied
 * into three files is a fact that will eventually disagree with itself. The
 * catalogs hold the prose and take these in as `{{placeholders}}`.
 *
 * `entity` is the name the documents are made in. Until a company is registered
 * it says "Fuelly", which is honest — the pages are then a disclosure by the
 * project rather than a contract with a legal person, and that is exactly what
 * they are today.
 *
 * `updated` is an ISO date, formatted for the reader by `localeTag()`. Change it
 * whenever the wording of either document changes in a way a reader would care
 * about — that date is the only way anyone can tell which version they agreed to.
 */
export const LEGAL_INFO = {
  entity: "Fuelly",
  contactEmail: "hello@fuelly.cloud",
  updated: "2026-08-22",
};
